import {Fragment} from "react";
import CustomFieldContent from "./CustomFieldContent";

export default function CustomFieldContainer({handleClose, customFields, filterCustomFieldList, customFieldsInput, handleCustomFieldFormData}) {

    return(
        <Fragment>
            <CustomFieldContent
                handleClose={handleClose}
                handleCustomFieldFormData={handleCustomFieldFormData}
                customFields={customFields}
                filterCustomFieldList={filterCustomFieldList}
                customFieldsInput={customFieldsInput}
            />
        </Fragment>
    )
}